import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Facebook, Instagram, Youtube, MessageCircle } from 'lucide-react';
import './Header.css';

const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About Us' },
    { to: '/ministries', label: 'Ministries' },
    { to: '/give', label: 'Give' },
    { to: '/contact', label: 'Contact' },
];

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [isMobileMenuOpen]);

    const closeMenu = () => setIsMobileMenuOpen(false);

    return (
        <>
            <header className={`header-wrap ${scrolled ? 'scrolled' : ''}`}>
                <div className="nav-pill">
                    {/* Logo */}
                    <Link to="/" className="pill-logo" onClick={closeMenu}>
                        <img src="/Images/paoz.png" alt="PAOZ HCC Logo" />
                        <span>PAOZ HCC</span>
                    </Link>

                    {/* Desktop Links */}
                    <nav className="pill-nav">
                        {navLinks.map(({ to, label }) => (
                            <Link
                                key={to}
                                to={to}
                                className={`pill-link ${location.pathname === to ? 'active' : ''}`}
                            >
                                {label}
                            </Link>
                        ))}
                    </nav>

                    {/* CTA */}
                    <div className="pill-right">
                        <Link to="/visit" className="pill-cta">Plan a Visit</Link>
                        <button
                            className="pill-toggle"
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>
            </header>

            {/* Mobile Overlay */}
            <div
                className={`mobile-overlay ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={closeMenu}
            />

            {/* Mobile Drawer */}
            <div className={`mobile-drawer ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="drawer-head">
                    <img src="/Images/paoz.png" alt="Logo" />
                    <button className="drawer-close" onClick={closeMenu}><X size={26} /></button>
                </div>

                <nav className="drawer-nav">
                    {navLinks.map(({ to, label }) => (
                        <Link
                            key={to}
                            to={to}
                            className={`drawer-link ${location.pathname === to ? 'active' : ''}`}
                            onClick={closeMenu}
                        >
                            {label}
                        </Link>
                    ))}
                    <Link to="/visit" className="btn btn-primary drawer-cta" onClick={closeMenu}>
                        Plan a Visit
                    </Link>
                </nav>

                <div className="drawer-socials">
                    <a href="https://www.facebook.com/Paozhcc" target="_blank" rel="noreferrer" title="Facebook">
                        <Facebook size={20} />
                    </a>
                    <a href="https://www.instagram.com/paoz_hope_community_church?igsh=ajJ0NGt0NGR2Yndq" target="_blank" rel="noreferrer" title="Instagram">
                        <Instagram size={20} />
                    </a>
                    <a href="https://www.youtube.com/@PAOZHCC" target="_blank" rel="noreferrer" title="YouTube">
                        <Youtube size={20} />
                    </a>
                    <a href="https://whatsapp.com/channel/0029VaoEAODE50UoeVr9sg2w" target="_blank" rel="noreferrer" title="WhatsApp Channel">
                        <MessageCircle size={20} />
                    </a>
                </div>
            </div>
        </>
    );
};

export default Header;
